import { useState } from "react"
import InfoBanner from "../Utils/InfoBanner"
import Instagram from "../Utils/Instagram"
import OurPick from "../Utils/OurPick"
import ShoppingBanner from "../Utils/ShoppingBanner"
import ShoppingCategory from "../Utils/ShoppingCategory"
import VideoBanner from "../Utils/VideoBanner"
import MyHeartsMate from "./MyHeartsMate"
import { BrandDetailItemProps } from "./constants"
import Cookies from "js-cookie"
import { NextSeo } from "next-seo"
import { Element, scroller } from 'react-scroll'


const MUGU = (props: BrandDetailItemProps) => {
  const viewport = Cookies.get('viewport');
  const [attrId, setAttrId] = useState(550);
  const [ipName, setIpName] = useState("Rose");

  const processScroll = () => {
    scroller.scrollTo('muguScrollToElement', {
      duration: 500,
      smooth: true,
      offset: -100,
    });
  }

  return (
    <>
      <NextSeo
        title=''
        defaultTitle='Mugu | Eco-Friendly Kids & Baby Feeding Set'
        description="Eco-friendly kids & baby feeding set, with Wheat Straw & Tritan materials. Functional in assisting baby to learn to eat/drink."
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/brand/mugu"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-middle.png",
            width: 577,
            height: 214,
            alt: 'mugu logo image',
          }]
        }}
      />
      {props.main_banner.length > 0 && props.main_banner[0].video !== null && (
        <VideoBanner
          video={props.main_banner[0].video}
          title={props.main_banner[0].text}
          brand_image={viewport === "desktop" ? process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-white-right.png" : process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-white-left.png"}
          brand_image_alt="mugo logo"
          brand_image_width={1000}
          brand_image_height={500}
          brand_image_style="max-w-[170px] md:max-w-[200px] mb-6"
          area_style="bottom-[106px] md:right-[100px]"
          style="justify-end text-right"
          mobile_style="justify-start text-left"
        />
      )}
      <MyHeartsMate setAttrId={setAttrId} setCustomName={setIpName} processScroll={processScroll} />
      {Object.keys(props.info_banner).length > 0 && (
        <InfoBanner
          desktop_image={props.info_banner.desktop_image}
          mobile_image={props.info_banner.mobile_image}
          image_alt={props.info_banner.image_alt}
          link={props.info_banner.link}
          style={props.info_banner.style}
          text={props.info_banner.text}
          desc={props.info_banner.desc}
          button_text={props.info_banner.button_text}
          custom_text={props.info_banner.custom_text}
          bg_color="bg-[#FAF7EF]"
          text_color="text-[#2C3E2F]"
          button_bg_color="bg-[#2C3E2F]"
          button_text_color="text-white"
          mb_button_bg_color="bg-[#2C3E2F]"
          mb_button_text_color="text-white"
        />
      )}
      {props.our_picks.length > 0 && (
        <div className="container" id="mugu-ourpick">
          <Element name="muguScrollToElement">
            <OurPick
              tittle={props.our_picks[0].tittle}
              see_all_link={props.our_picks[0].see_all_link}
              banner_list={props.our_picks[0].banner_list}
              product_list={props.our_picks[0].product_list}
              attrId={attrId}
              customName={null}
              expandColor={false}
              showBorder={false}
            />
          </Element>
        </div>
      )}
      {props.shopping_category.length > 0 && (
        <ShoppingCategory
          banner_list={props.shopping_category}
          title=""
        />
      )}
      {props.shopping_banners.length > 0 && (
        <ShoppingBanner
          banners={props.shopping_banners}
          brand_image={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-white-left.png"}
          brand_image_alt="mugu logo"
          brand_image_style="mb-12"
          bg_color=""
          text_color="text-white"
          style=""
          button_bg_color="bg-[#2C3E2F]"
          button_text_color="text-white"
        />
      )}
      {props.instagram.length > 0 && (
        <Instagram
          instagram={props.instagram}
          title="Find more about mugu on Instagram"
          mobile_title="Find more about<br />mugu on Instagram"
        />
      )}
    </>
  )
}

export default MUGU
